import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ToastService.css";

const toastPosition = "bottom-left";

const convertFontSize = (mag = "") => {
  return (
    <span
      style={{
        fontSize: "18px",
      }}>
      {mag}
    </span>
  );
};

const ToastService = {
  defaultToast: (message: any, id = "") =>
    toast(convertFontSize(message), {
      toastId: id,
      autoClose: 3000,
      draggable: true,
      closeOnClick: true,
      pauseOnHover: true,
      hideProgressBar: true,
      position: toastPosition,
    }),

  SuccessToast: (message: any, id = "") =>
    toast.success(convertFontSize(message), {
      toastId: id,
      autoClose: 3000,
      draggable: true,
      closeOnClick: true,
      pauseOnHover: true,
      hideProgressBar: true,
      position: toastPosition,
      theme: "colored",
      style: { background: "#2E7D32" },
    }),

  failToast: (message: any, id = "") =>
    toast.error(convertFontSize(message), {
      toastId: id,
      autoClose: 3000,
      draggable: true,
      closeOnClick: true,
      pauseOnHover: true,
      hideProgressBar: true,
      position: toastPosition,
      theme: "colored",
      style: { background: "#d32f2f" },
    }),

  warnToast: (message: any, id = "") =>
    toast.warn(convertFontSize(message), {
      toastId: id,
      autoClose: 3000,
      draggable: true,
      closeOnClick: true,
      pauseOnHover: true,
      hideProgressBar: true,
      position: toastPosition,
    }),

  infoToast: (message: any, id = "") =>
    toast.info(convertFontSize(message), {
      toastId: id,
      autoClose: 3000,
      draggable: true,
      closeOnClick: true,
      pauseOnHover: true,
      hideProgressBar: true,
      position: toastPosition,
    }),

  dismissToast: (toastId = "") => toast.dismiss(toastId),
};

export default ToastService;
